import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { lockRUStatusDashboardAdministrativeState } from '@api/ruStatusDashboard';

import { IRUStatusDashboardToggleAvailabilityDTO } from '@interfaces/ruStatusDashboard/dto/ruStatusDashboardDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { RU_DASHBOARD_LOCK, RU_DASHBOARD_STATUSES } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateLockRUDashboardStatusReturned {
	lockRUStatusDashboardAdministrativeState: UseMutateFunction<
		any,
		any,
		IRUStatusDashboardToggleAvailabilityDTO,
		any
	>;
	isLoadingLockRUDashboardStatus: boolean;
}

export const useMutateLockRUDashboardStatus = (): IUseMutateLockRUDashboardStatusReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IRUStatusDashboardToggleAvailabilityDTO>({
		mutationKey: [RU_DASHBOARD_LOCK],
		mutationFn: lockRUStatusDashboardAdministrativeState,
		allowedRoles: [EUserRoles.smoLightUpdater],
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateRuConfiguration,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([RU_DASHBOARD_STATUSES])];
		},
	});

	return {
		lockRUStatusDashboardAdministrativeState: mutate,
		isLoadingLockRUDashboardStatus: isLoading,
	};
};
